export default Object.freeze({
    PersonalApoyo : "PersonalApoyo",
    StaffProvider : "Staff Provider",
    Evaluador : "Evaluador",
    Distrito : "Distrito",
    AdminProvider : "AdminProvider",
    MaestroPrivado : "Maestro Privado",
    Registro : "Registro",
    ProveedorRP : "Proveedor RP",
    Monitores : "Monitores",
    InterventorCentro : "Interventor - Centro",
    DirectorCentro : "Director Centro",
    RecursosHumanosRP : "Recursos Humanos - RP",
    Contratos : "Contratos",
    Centro : "Centro",
    InvestigadorRemedioProvisional : "Investigador Remedio Provisional",
    Consultor : "Consultor",
    DivisionLegalUnidadSeguimiento : "Division Legal - Unidad Seguimiento",
    FacilitadorMunicipios : "Facilitador-Municipios",
    RegistroSolicitudRemedioProvisional : "Registro Solicitud Remedio Provisional",
    PreInterventorRP : "Pre Interventor RP",
    BecaAsistencia : "Beca Asistencia",
    UMESRURP : "UMESR URP",
    ProveedorRegion : "ProveedorRegion ",
    AbogadoDLEE : "Abogado DLEE",
    RemedioProvisional : "Remedio Provisional",
    Especialista : "Especialista",
    ParteC : "Parte C",
    UMESR : "UMESR",
    Provider : "Provider",
    ProveedorCPA : "Proveedor CPA",
    AdminProInfo : "AdminProInfo",
    Proponente : "Proponente",
    Técnico : "Técnico",
    FacilitadorRegion : "Facilitador_Region",
    AsistenteProveedor : "Asistente Proveedor",
    AdminKnumetrix : "AdminKnumetrix",
    Region : "Region",
    FinanzasRP : "Finanzas RP",
    Director : "Director",
    TrainingMaestro : "Training Maestro",
    Escuela : "Escuela",
    EspecialistaRP : "Especialista RP",
    ChequesRP : "ChequesRP",
    Maestro : "Maestro",
    ApoyoTecnico : "Apoyo_Tecnico",
    ContratoSAEE : "Contrato SAEE",
    MaestroTransitorio : "Maestro Transitorio",
    AdminRSM : "AdminRSM",
    TestRole : "TestRole",
    ProgramaDeEducacionparaAdultos : "Programa de Educacion para Adultos (PEA)",
    Padre : "Padre",
    Central : "Central",
    SupervisorProveedor : "Supervisor Proveedor",
    AdminProInfoRP : "AdminProInfo-RP",
    Administrador : "Administrador",
    TecnicoRecursosHumanos : "TecnicoRecursosHumanos",
    catlib : "catlib",
    PEI : "PEI",
    FacilitadorDistrito : "Facilitador-Distrito",
    AdministradorRP : "Administrador RP",
    Requirente : "Requirente",
    SupervisorProveedorRP : "Supervisor Proveedor RP",
    AdminSAEE : "AdminSAEE",
    AdminIL : "AdminIL",
    Facilitador : "Facilitador",
    AsistenciaTecnica : "Asistencia Técnica",
    CentroIsla : "Centro-Isla",
    DirectorURP : "Director URP",
    ApoyoACentro : "Apoyo a Centro",
  });